/*
 * Uma região do grid cujo conteúdo veio do SERVIDOR e é ADOTADO pelo React.
 *
 * Os nós são MOVIDOS, não reserializados: `dangerouslySetInnerHTML` reparsearia os ~18 KB de
 * HTML do CMS e destruiria a identidade de cada nó do corpo. Aqui o `<article-body>` do PHP é
 * esvaziado num `DocumentFragment` antes do render, e este componente o pendura no elemento
 * que ele mesmo cria — o resultado é o mesmo DOM de sempre, com as mesmas instâncias de nó.
 *
 * `useLayoutEffect` e não `useEffect`: o conteúdo entra ANTES do browser pintar, senão a
 * região aparece vazia por um frame — e ela é o artigo.
 *
 * O React não sabe destes filhos, e é de propósito: o componente renderiza um elemento SEM
 * children, então nenhuma re-renderização mexe no que foi pendurado.
 */
import React, { useLayoutEffect, useRef } from 'react';

interface IAdoptedRegionProps {
    /** Os nós vindos do SSR. Já esvaziado depois da primeira montagem. */
    content: DocumentFragment | null;
    /** Tag do elemento que recebe os nós — `header` no cabeçalho, `div` no corpo. */
    as?: 'div' | 'header';
    className?: string;
    id?: string;
}

const AdoptedRegion: React.FC<IAdoptedRegionProps> = ({ content, as = 'div', className, id }) => {
    const ref = useRef<HTMLElement>(null);

    useLayoutEffect(() => {
        if (ref.current && content) ref.current.appendChild(content);
    }, [content]);

    return React.createElement(as, { ref, className, id });
};

export default AdoptedRegion;
